import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import ButtonBase from '../ButtonBase';

const IconButton = React.forwardRef(function IconButton({ className, children, ...props }, ref) {
  return (
    <Button ref={ref} className={className} {...props}>
      <Label>{children}</Label>
    </Button>
  );
});

IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

IconButton.displayName = 'IconButton';

const Button = styled(ButtonBase)`
  flex: 0 0 auto;
  padding: 3px;
  overflow: visible;
  text-align: center;

  &:disabled {
    background-color: transparent;
    opacity: 0.5;
    color: grey;
  }
  &:hover,
  &:focus {
    background-color: transparent;
  }
`;

const Label = styled.span`
  width: 100%;
  display: flex;
  justify-content: inherit;
  align-items: inherit;
`;

export default IconButton;
